// import React from 'react';
// import { Link } from 'react-router-dom';
// import Banner from '../components/Banner';
// import banner from '../assests/contactBanner.png';
// import Banner2 from '../components/Banner2';
// import notfoundimg from '../assests/oops.avif'
// export default function NotFound() {
//   return (
//     <div>
//          {/* <Banner
//         src={banner}
//         title="Page Not Found"
//         text=""
//         updated=""
//         buttonUrl=""
//         buttonText=""
//       />
//            <Banner2
//         src={banner}
//         title=""
//         text="Page Not Found"
//         updated=""
//         buttonUrl=""
//         buttonText=""
//       /> */}
//               <div className="text-center m-5">
//               <img
//           src={notfoundimg}
//           alt="Card"
//           className="w-1/3 h-1/3 object-cover opacity-100 text-center justify-center m-auto"
//         />
//        <h2 className=" font-bold text-5xl">404 -  <span className="text-textBlue">Page Not Found</span></h2>
//        <h6 className="m-auto text-center text-xl  p-3">Our Sorry, the page you are looking for does not exist.</h6>
//       <Link to="/" className="px-6 py-2 bg-gradient-to-r from-textBlue to-ultragreen text-white rounded-md hover:from-ultragreen hover:to-textBlue focus:outline-none ">Go back to Home</Link>
//     </div>
//     </div>
//   );
// }


import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
// import comingSoonImg from '../assests/coming-soon.avif'; // Replace with your image

export default function NotFound() {
  const [countdown, setCountdown] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0
  });

  // Set your target launch date here
  const launchDate = new Date('2025-12-31T00:00:00').getTime();

  useEffect(() => {
    const interval = setInterval(() => {
      const now = new Date().getTime();
      const distance = launchDate - now;

      if (distance > 0) {
        setCountdown({
          days: Math.floor(distance / (1000 * 60 * 60 * 24)),
          hours: Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)),
          minutes: Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60)),
          seconds: Math.floor((distance % (1000 * 60)) / 1000)
        });
      } else {
        clearInterval(interval);
        setCountdown({ days: 0, hours: 0, minutes: 0, seconds: 0 });
      }
    }, 1000);

    return () => clearInterval(interval);
  }, [launchDate]);

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 via-white to-green-50 flex items-center justify-center">
      <div className="text-center px-4 py-8 max-w-4xl mx-auto">
        {/* Image */}
        <div className="mb-8 animate-bounce-slow">
          {/* <img
            src={comingSoonImg}
            alt="Coming Soon"
            className="w-64 h-64 md:w-80 md:h-80 object-cover mx-auto rounded-full shadow-2xl"
          /> */}
        </div>

        {/* Main Heading */}
        <h1 className="font-bold text-5xl md:text-6xl mb-4">
          <span className="bg-gradient-to-r from-textBlue to-ultragreen bg-clip-text text-transparent">
            Coming Soon
          </span>
        </h1>

        {/* Subheading */}
        <h2 className="text-2xl md:text-3xl font-semibold text-gray-700 mb-6">
          Something Amazing is on the Way!
        </h2>

        {/* Description */}
        <p className="text-xl text-gray-600 mb-10 max-w-2xl mx-auto">
          We're working hard to bring you an exceptional experience. 
          Stay tuned for something special!
        </p>

        {/* Countdown Timer */}
        {/* <div className="grid grid-cols-4 gap-4 md:gap-8 mb-10 max-w-2xl mx-auto">
          {[
            { label: 'Days', value: countdown.days },
            { label: 'Hours', value: countdown.hours },
            { label: 'Minutes', value: countdown.minutes },
            { label: 'Seconds', value: countdown.seconds }
          ].map((item, index) => (
            <div 
              key={index} 
              className="bg-white rounded-lg shadow-lg p-4 md:p-6 border-2 border-gray-100 hover:border-textBlue transition-all duration-300"
            >
              <div className="text-3xl md:text-5xl font-bold bg-gradient-to-r from-textBlue to-ultragreen bg-clip-text text-transparent">
                {String(item.value).padStart(2, '0')}
              </div>
              <div className="text-sm md:text-base text-gray-600 font-medium mt-2">
                {item.label}
              </div>
            </div>
          ))}
        </div> */}

        {/* Email Notification (Optional) */}
        {/* <div className="mb-8 max-w-md mx-auto">
          <p className="text-gray-700 mb-4 font-medium">Get notified when we launch</p>
          <div className="flex flex-col sm:flex-row gap-3">
            <input
              type="email"
              placeholder="Enter your email"
              className="flex-1 px-4 py-3 rounded-lg border-2 border-gray-300 focus:border-textBlue focus:outline-none transition-colors"
            />
            <button className="px-6 py-3 bg-gradient-to-r from-textBlue to-ultragreen text-white rounded-lg hover:from-ultragreen hover:to-textBlue focus:outline-none font-semibold shadow-lg hover:shadow-xl transition-all duration-300">
              Notify Me
            </button>
          </div>
        </div> */}

        {/* Home Button */}
        <Link 
          to="/" 
          className="inline-block px-8 py-3 bg-gradient-to-r from-textBlue to-ultragreen text-white rounded-lg hover:from-ultragreen hover:to-textBlue focus:outline-none font-semibold shadow-lg hover:shadow-xl transition-all duration-300"
        >
          Go back to Home
        </Link>

        {/* Social Links (Optional) */}
        {/* <div className="mt-10">
          <p className="text-gray-600 mb-4">Follow us for updates</p>
          <div className="flex justify-center gap-6">
            <a href="#" className="text-gray-500 hover:text-textBlue transition-colors">
              <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
                <path d="M24 4.557c-.883.392-1.832.656-2.828.775 1.017-.609 1.798-1.574 2.165-2.724-.951.564-2.005.974-3.127 1.195-.897-.957-2.178-1.555-3.594-1.555-3.179 0-5.515 2.966-4.797 6.045-4.091-.205-7.719-2.165-10.148-5.144-1.29 2.213-.669 5.108 1.523 6.574-.806-.026-1.566-.247-2.229-.616-.054 2.281 1.581 4.415 3.949 4.89-.693.188-1.452.232-2.224.084.626 1.956 2.444 3.379 4.6 3.419-2.07 1.623-4.678 2.348-7.29 2.04 2.179 1.397 4.768 2.212 7.548 2.212 9.142 0 14.307-7.721 13.995-14.646.962-.695 1.797-1.562 2.457-2.549z"/>
              </svg>
            </a>
            <a href="#" className="text-gray-500 hover:text-textBlue transition-colors">
              <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
                <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
              </svg>
            </a>
            <a href="#" className="text-gray-500 hover:text-textBlue transition-colors">
              <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
                <path d="M22.675 0h-21.35c-.732 0-1.325.593-1.325 1.325v21.351c0 .731.593 1.324 1.325 1.324h11.495v-9.294h-3.128v-3.622h3.128v-2.671c0-3.1 1.893-4.788 4.659-4.788 1.325 0 2.463.099 2.795.143v3.24l-1.918.001c-1.504 0-1.795.715-1.795 1.763v2.313h3.587l-.467 3.622h-3.12v9.293h6.116c.73 0 1.323-.593 1.323-1.325v-21.35c0-.732-.593-1.325-1.325-1.325z"/>
              </svg>
            </a>
          </div>
        </div> */}
      </div>
    </div>
  );
}
